import { StanDropdownMenu } from './Menu/StanDropdownMenu';
import { StanDropdownInput } from './Input/StanDropdownInput';
import { StanDropdownProps } from './StanDropdown.types';
import { DropdownProvider, useDropdown } from './DropdownProvider';
import { useMemo } from 'react';
import styles from './Menu/StanDropdownMenu.module.css';
import { cn } from '@/lib/utils/cn';

const StanDropdownContent: React.FC<StanDropdownProps> = props => {
    const { internalValue, setInternalValue } = useDropdown();

    // Find the icon for the currently selected option
    const selectedIcon = useMemo(() => {
        if (!internalValue?.value) return undefined;
        const selectedOption = props.options.find(opt => opt.value === internalValue.value);
        const icon = selectedOption?.icon;
        if (typeof icon === 'string') {
            return <img src={icon} alt='' className={cn(styles.imageWrapper, 'mr-2')} />;
        }
        return icon;
    }, [internalValue?.value, props.options]);

    return (
        <StanDropdownMenu
            {...props}
            onSelect={(value, option) => {
                const preventDeselect = props.preventDeselect ?? false;
                const newValue = !preventDeselect && internalValue?.value === value.value ? null : value;
                setInternalValue(newValue);
                props.onSelect(value, option);
            }}
            currentValue={internalValue}
        >
            <StanDropdownInput
                id={props.id}
                name={props.name}
                value={internalValue?.label}
                placeholder={props.placeholder || 'Select an option'}
                required={props.required}
                disabled={props.disabled}
                hintText={props.hintText}
                error={props.error}
                label={props.label}
                startIcon={selectedIcon}
                className='w-full'
            />
        </StanDropdownMenu>
    );
};

export const StanDropdown: React.FC<StanDropdownProps> = props => {
    return (
        <DropdownProvider initialValue={props.currentValue ?? null} dropdownId={props.id} dropdownName={props.name}>
            <StanDropdownContent {...props} />
        </DropdownProvider>
    );
};
